module.exports = __webpack_public_path__ + "static/media/Microdeposit-yellow.01e6837d.png";